import Languages from './Languages'

const Flags = {
  [Languages.en_US]: {
    code: 'GB',
    country: 'United Kingdom'
  },
  [Languages.pl_PL]: {
    code: 'PL',
    country: 'Polska'
  }
}

export default Flags
